import getTripDuration from "@/utils/getTripDuration.js";

export default function getTripTitle(item) {
    if(item === undefined || item === null) return "";
    let prefix = "";
    if(!item?.hotel) prefix += "[Tylko lot] "
    let tripDuration = getTripDuration(item);
    if(item.durationInDays !== undefined) {
        tripDuration = item.durationInDays;
    }
    let localizer = "w";
    let destinationInfo = item?.destination;
    // `inName` can be missing, undefined, OR explicitly null (e.g. flight-only trips from /find/flights) -
    // a strict `=== undefined` check let `null` slip through and get stringified as literal "null" in the title.
    if(!destinationInfo?.inName) {
        destinationInfo = item?.destinationData;
    }
    if(!destinationInfo?.inName && typeof item?.destination === "string") {
        // last resort: `destination` is a plain name string rather than an object with inName/prefix
        destinationInfo = {inName: item.destination};
    }
    destinationInfo = destinationInfo || {};
    if(destinationInfo.prefix) {
        let possiblePrefix = destinationInfo.prefix;
        if(possiblePrefix !== "") {
            localizer = possiblePrefix;
        }
    }

    const destinationName = destinationInfo.inName || destinationInfo.name || item?.destination?.name || "";
    return prefix + `${tripDuration} dni ${localizer} ${destinationName} za ${Math.round(item?.pricePerPerson)} zł za osobę`;
}